import ViewContainer from "./ViewContainer"


const HomeView = () => {
  return (
    <ViewContainer>
      <h1>Welcome to Statwatch!</h1>

      <img
        width="400"
        src="https://media.tenor.com/stP_Yv5G3QsAAAAS/oh-the-misery-everybody-wanna-be-my-enemy.gif"
      />

    </ViewContainer>
  )
}

export default HomeView